<template>
  <div class="menu-wrapper">
    <div class="page-title">权限管理</div>

    <div class="content-wrapper">
      <div class="content-left">
        <p class="sub-title">菜单列表</p>
        <menu-tree @handle-get-list="handleGetList" :query-all="true" />
      </div>

      <div class="content-right">
        <p class="sub-title">
          配置权限 - 当前角色: {{ $route.query.name }}
        </p>

        <Contents
          style="height: 100%"
          v-loading="loading"
          ref="contentRef"
          :table-data="list.results"
          :total="list.totalCount"
          @handle-page-change="handleGetList"
        >
         <template #default="{ row }">
           <div class="action-wrapper">
              <el-switch
                style="margin-right: 20px"
                :active-value="1"
                :inactive-value="0"
                active-color="#3550E1"
                v-model="row.toggleStatus"
                @change="handleChangeAuth(row)"
              ></el-switch>
              <span style="padding-right: 10px" v-if="row.scope.length">数据范围:</span>
              <el-radio-group
                v-model="row.scopeAuth"
                @change="handleChangeRange(row)"
              >
                <el-radio
                  v-for="item in getDataRange(row, dataRangeOptions)"
                  :key="item.id"
                  :label="item.id"
                >{{ item.name }}</el-radio>
              </el-radio-group>
           </div>
            <!-- <el-button type="text" @click="handleDelete(row)">删除</el-button> -->
          </template>
        </Contents>
      </div>
    </div>
  </div>
</template>

<script>
import MenuTree from '../components/MenuTree'
import Contents from './Contents'
import Services from '@/services/api/backstage'

export default {
  components: {
    MenuTree,
    Contents,
  },
  data() {
    return {
      loading: false,
      list: {},
      dataRangeOptions: [
        {
          id: 1,
          name: '个人',
        },
        {
          id: 2,
          name: '部门',
        },
        {
          id: 3,
          name: '部门(含下级)',
        },
        {
          id: 4,
          name: '全部',
        },
      ],
      menuInfo: {},
    };
  },
  computed: {
    getDataRange() {
      return (row, dataRangeOptions) => {
        const optionsList = []
        dataRangeOptions.map((item) => {
          if (row.scope.includes(item.id)) {
            optionsList.push(item)
          }
          return item
        })
        return optionsList
      }
    },
  },
  mounted() {},
  methods: {
    async handleGetList(val) {
      if (val !== undefined) this.menuInfo = val
      try {
        this.loading = true
        const { id } = this.menuInfo
        const { roleId } = this.$route.query
        const page = this.$refs.contentRef.page
        if (val) page.pageNumber = 1
        const params = { menuId: id, roleId, ...page }
        const { data } = await Services.apiQueryAuthByRoleId({ ...params })
        this.list = data
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },

    async handleChangeAuth(row) {
      const { roleId } = this.$route.query
      const { 
        id, toggleStatus, scopeAuth, scope,
      } = row
      const params = {
        roleId, menuId: id, toggleStatus, scopeAuth, 
      }

      if (!scope.includes(scopeAuth) && scope.length) {
        this.$message.error('请选择数据范围')
        row.toggleStatus = Number(!row.toggleStatus)
      } else {
        try {
          await Services.apiToggleAuth(params)
          this.$message.success('操作成功')
          this.handleGetList()
        } catch (error) {
          console.log(error)
        }
      }
    },

    async handleChangeRange(row) {
      console.log(row.scopeAuth)
      row.toggleStatus = 1
      this.handleChangeAuth(row)
    },
  },
};
</script>

<style scoped lang="less">
@import '~@/styles/var.less';
@import '~@/styles/const.less';

.menu-wrapper {
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
  height: 100%;

  .page-title {
    height: 33px;
    margin-bottom: 10px;
    font-size: @font-size--max;
    color: @color--info;
    line-height: 33px;
    line-height: 33px;
  }
  .sub-title {
    position: relative;
    line-height: 40px;
    color: @color--info;
    font-size: 14px;
    padding-left: 20px;
    font-weight: 500;
    &::after {
      content: ' ';
      position: absolute;
      left: 5px;
      top: 12px;
      width: 5px;
      height: 15px;
      background-color: @color--link;
      border-radius: 4px;
    }
  }
  .content-wrapper {
    display: flex;
    flex: 1;

    .content-left {
      box-sizing: border-box;
      width: 230px;
      height: 100%;
      overflow: auto;
      background-color: @bg--white;
      box-shadow: @box-shadow;
      border-radius: 4px;
    }

    .content-right {
      position: relative;
      display: flex;
      flex-direction: column;
      flex: 1;
      background-color: @bg--white;
      margin-left: 20px;
      overflow: auto;
      box-shadow: @box-shadow;
      border-radius: 4px;

      .action-wrapper {
        display: flex;
        align-items: center;
        justify-content: flex-start;
      }
    }
  }
}
</style>
